module.exports = __webpack_public_path__ + "img/news_promo.046304ea.png";